import axios from '@axios'

const PREFIX = '/pre-geracao-contratos'

export default {
  source: null,
  enviarContratoParaAssinatura(propostaId, assinantes, enviarEmail = true) {
    // API expects the body to be an array of DocumentoAssinanteDTO objects
    // so send the array directly instead of wrapping it in an object
    return axios.post(`${PREFIX}/enviar-para-assinar/${propostaId}?enviarEmail=${enviarEmail}`, assinantes)
  },

  updatePreGeracaoContrato(id, preGeracaoContrato) {
    return axios.post(`${PREFIX}/contrato/${id}`, preGeracaoContrato)
  },
  getSociosMatriz(request, tokenCancel) {
    this.source = tokenCancel.source()
    return axios.post(`${PREFIX}/matriz-socios`, request, { cancelToken: this.source.token })
  },

  getEmpresasPreGeracao(respostas, empresaId, tokenCancel) {
    this.source = tokenCancel.source()
    return axios.post(`${PREFIX}/empresas-geracao?empresaId=${empresaId}`, respostas, { cancelToken: this.source.token })
  },

  getQualificacaoSocio(socioId, externo) {
    if (externo) {
      return axios.get(`${PREFIX}/portal-propostas/qualificacao-socio/${socioId}`)
    }
    return axios.get(`${PREFIX}/qualificacao-socio/${socioId}`)
  },

  salvarEscolhaFaturamento(id, preGeracaoContrato) {
    return axios.post(`${PREFIX}/${id}/escolha-faturamento`, preGeracaoContrato)
  },

  cancelarBusca() {
    this.source.cancel()
  },
}
